import { css } from "@emotion/css"

type Props = { width?: number }

const Divider = ({ width }: Props) => {
  return <div style={{ width }} className={styles.divider} />
}

export default Divider

const styles = {
  divider: css`
    border-top: 1px solid #c2cdd6;
  `,
}
